import { render, staticRenderFns } from "./demo_date_form.vue?vue&type=template&id=a9638370"
import script from "./demo_date_form.vue?vue&type=script&lang=js"
export * from "./demo_date_form.vue?vue&type=script&lang=js"
import style0 from "./demo_date_form.vue?vue&type=style&index=0&id=a9638370&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports